import { createContext, useContext, useEffect, useState } from "react";
import { cmsCall } from "@/lib/cms";

const SiteContext = createContext({ site: null, menus: [], instellingen: null, loading: true });

export function SiteProvider({ children }) {
  const [state, setState] = useState({ site: null, menus: [], instellingen: null, loading: true });

  useEffect(() => {
    let cancelled = false;
    cmsCall("GET", "/content/site")
      .then((data) => {
        if (!cancelled) setState({ ...data, loading: false });
      })
      .catch(() => {
        if (!cancelled) setState({ site: null, menus: [], instellingen: null, loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <SiteContext.Provider value={state}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext);
}

/** Menu-item -> href */
export function itemHref(item) {
  if (!item) return "/";
  if (item.soort === "pagina") return item.waarde === "home" ? "/" : `/${item.waarde}`;
  if (item.soort === "extern") return item.waarde;
  return item.waarde || "/";
}
